import ManageVendor from "../pages/SideTabPages/ManageVendor";

export default {
  API_URL: "https://api.delivitapp.com/",
  // PUBLIC
  GET_HOME: "api/v1/user/home",
  GET_SERVICES_TYPES: "api/v1/user/getWithFilter",
  GET_PICK_UP_LISTING: "api/v1/user/pickupSizelisting",
  GET_ESTIMATED_PRICE: "api/v1/booking/checkMinimumEstimatedChargesV2",
  PICKUP_DROP_SAVE: "api/v1/user/delvit/pickupDropoffLocation/save",
  // Delivit url for public url.
  DELVIT_URL: "https://delivitapp.com/",

  // ADMIN
  LOGIN_ADMIN: "api/v1/vendor/vendorLogin",
  FORGET_PASSWORD_ADMIN: "/api/v1/vendor/forgotPassword",
  OTP_VERIFY: "/api/v1/vendor/verifyOTP",
  RESET_PASSWORD: "/api/v1/vendor/resetPassword",
  CHANGE_PASSWORD: "/api/v1/vendor/changePassword",
  AMDIN_UPDATE: "/api/v1/vendor/editVendor",

  // bird eye view

  BIRD_EYE_VIEW: "api/v1/admin/provider/birdeyeview",

  // dashbaord
  GET_DASHBOARD_DATA: "/api/v1/vendor/dashboardReport",
  // customer
  GET_CUSTOMERS: "/api/v1/admin/getUsersWithFilter",
  BLOCK_UNBLOCK_CUSTOMER: "/api/v1/admin/blockUnblockCustomer",
  GET_CUSTOMERS_BY_ID: "/api/v1/admin/view/",
  EXPORT_CUSTOMER_CSV: "/api/v1/admin/exportsUser",
  IMPORT_CUSTOMER_CSV: "/api/v1/admin/importUserViaCSV",
  // promotions
  GET_PROMOTIONS: "/api/v1/admin/promotion/getWithFilters",
  PROMOTION_STATUS_UPDATE: "/api/v1/admin/promotion/update/status",
  PROMOTION_DELETE: "/api/v1/admin/promotion/delete/",
  PROMOTION_ADD: "/api/v1/admin/promotion/add",
  PROMOTION_EDIT: "/api/v1/admin/promotion/edit",
  GET_PROMOTION_BY_ID: "/api/v1/admin/promotion/getById/",

  // promoCode
  GET_PROMO_CODES: "/api/v1/admin/promocodes/getWithFilters",
  ADD_PROMO_CODE: "/api/v1/admin/promocodes/add",
  DELETE_PROMO_CODE: "/api/v1/admin/promocodes/delete/",
  GET_PROMO_CODE_BY_ID: "/api/v1/admin/promocodes/getById/",
  PROMO_CODE_EDIT: "/api/v1/admin/promocodes/edit",

  //  system access
  ADD_ADMIN: "/api/v1/admin/addSubadmin",
  REMOVE_ADMIN: "/api/v1/admin/removeUser",
  GET_ADMIN_LIST: "/api/v1/admin/getAllAdminList",
  GET_ADMIN_BY_ID: "/api/v1/vendor/getDetailById/",
  EDIT_SYSTEM_ADMIN: "/api/v1/vendor/editVendor",

  // manage booking

  GET_MANAGE_BOOKINGS: "/api/v1/adminDashboard/allBookingsWithFilter",
  GET_MANAGE_BOOKING_DETAILS: "/api/v1/adminDashboard/bookingDetail/",

  // Services

  GET_SERVICES: "/api/v1/service/getWithFilter",
  ADD_SERVICE: "/api/v1/service/add",
  GET_SERVICE_BY_ID: "/api/v1/service/getById/",
  REMOVE_SERVICE: "/api/v1/service/remove",
  EDIT_SERVICE: "/api/v1/service/update",
  BLOCK_UNBLOCK_SERVICE: "/api/v1/service/blockUnblock",

  // reports

  GET_DRIVERS_REPORTS: "/api/v1/adminDashboard/report/driverlisting",
  EXPORT_DRIVERREPORT_CSV: "/api/v1/admin/exportsReportData",

  // accounting

  GET_ACCOUNTING_DATA: "/api/v1/vendor/transaction",
  // GET_ACCOUNTING_DATA: "/api/v1/vendor/transaction",
  EXPORT_ACCOUNTING_CSV: "/api/v1/adminDashboard/exportsaccounting",

  // fare request

  GET_FARE_REQUESTS: "/api/v1/fareRequest/getWithFilter",
  GET_FARE_REQUEST_VIEW: "/api/v1/fareRequest/view/",
  FARE_REQUEST_APPROVE: "/api/v1/fareRequest/updatetestatus",

  // agencies
  GET_AGENCIES: "/api/v1/admin/provider/getWithFilter?status=",
  APPROVING_AGENCY: "/api/v1/admin/provider/onAccountApprovalByAdmin",
  BLOCK_UNBLOCK_AGENCY: "/api/v1/admin/provider/blockUnblock",
  GET_AGENCY_VIEW: "/api/v1/admin/provider/view/",
  ADD_AGENCY: "/api/v1/admin/provider/add",
  UPDATE_AGENCY: "/api/v1/admin/provider/edit",
  DELETE_AGENCY: "/api/v1/admin/provider/remove",
  GET_AGENCY_BY_ID: "/api/v1/admin/provider/getById/",
  EXPORT_AGENCIES_CSV: "/api/v1/admin/provider/exportsProviders",
  IMPORT_AGENCIES_CSV: "/api/v1/admin/provider/importProvidersViaCSV",

  // drivers
  GET_DRIVERS: "/api/v1/admin/provider/getDriversWithFilter?status=",
  APPROVING_DRIVER: "/api/v1/admin/provider/onAccountApprovalByAdmin",
  BLOCK_UNBLOCK_DRIVER: "/api/v1/admin/provider/blockUnblock",
  VIEW_DRIVER: "/api/v1/admin/provider/viewdriver/",
  ADD_DRIVER: "/api/v1/admin/provider/addDriver",
  UPDATE_DRIVER: "/api/v1/admin/provider/updateDriver",
  DELETE_DRIVER: "api/v1/admin/provider/deleteDriver",
  GET_DRIVER_BY_ID: "/api/v1/admin/provider/getById/",
  EXPORT_DRIVERS_CSV: "/api/v1/admin/provider/exportsDrivers",
  IMPORT_DRIVERS_CSV: "/api/v1/admin/provider/importDriverViaCSV",

  // dispute
  GET_DISPUTES: "/api/v1/dispute/getWithFilters",
  GET_DISPUTE_VIEW: "/api/v1/dispute/actionview/",
  UPDATE_STATUS_DISPUTE: "/api/v1/dispute/updateDisputeStatus",

  // file upload
  FILE_UPLOAD: "/api/v1/adminSetting/uploadFile",
  // ================= SETTINGS =================== //
  BASIC_SETTING_DETAILS: "/api/v1/adminSetting/getBasicSettingInfo",
  GET_CONFIG_DETAILS: "adminSetting/getConfigInfo",
  BASIC_SETTING_UPDATE: "api/v1/adminSetting/basicAppSetting",
  GET_CONFIG_UPDATE: "adminSetting/twilio/update",
  GET_MAIL_UPDATE: "adminSetting/mailgun/update",
  PAYMENT_CONFIG_UPDATE: "adminSetting/paymentConfig/update",
  ANDROID_VERSION_UPDATE: "adminSetting/appVersion/update",
  ANDROID_APP_URL_UPDATE: "adminSetting/androidAppUrl/update",
  IOS_APP_URL_UPDATE: "adminSetting/iosAppURL/update",
  GET_MAIL_TEMPLATES: "/api/v1/adminSetting/mailTemplate/all",
  MAIL_TEMPLATES_UPDATE: "/api/v1/adminSetting/mailTemplate/edit",
  GET_SMS_TEMPLATES: "/api/v1/adminSetting/smsTemplate/all",
  SMS_TEMPLATES_UPDATE: "/api/v1/adminSetting/smsTemplate/edit",
  // faq
  FAQ_LIST: "/api/v1/admin/getAllFaqs",
  ADD_FAQ: "/api/v1/admin/addFaq",
  GET_FAQ_BY_ID: "/api/v1/admin/getFaqsById/",
  EDIT_FAQ: "/api/v1/admin/editFaq",
  DELETE_FAQ: "/api/v1/admin/deleteFaq",
  STATUS_CHANGE_FAQ: "/api/v1/admin/blockUnblockFaq",

  // content page
  CONTENTPAGE_LIST: "/api/v1/admin/contents",
  CONTENTPAGE_EDIT: "/api/v1/admin/contents/update",
  CONTENT_LIST_DETAILS: "/api/v1/admin/contents/edit/",
  STATUS_CHANGE_CONTENT: "/api/v1/admin/contents/blockUnblock",

  //Public Link for Get it by delvit product.
  PRODUCT_GETIT_BY_DELIVIT: "/product/delvit",

  // Vendor
  GET_MANAGE_VENDOR: "/api/v1/vendor/allGuestBookingsWithFilter",
  GET_MANAGE_VENDOR_DETAILS: "/api/v1/vendor/guestbookingDetail/",

  // Payment 
  ADD_CARD: "api/v1/payment/guest/addpos",
  MAKE_PAYMENT: "api/v1/booking/guest/payment",

  VENDOR_STRIPE_PROVIDER_CONNECT: "api/v1/provider/vendorstripe/connect",
  VENDOR_STRIPE_PROVIDER_CONNECT_DETAIL: "api/v1/provider/vendorstripe/connect/details",
  VENDOR_SIGNUP: "api/v1/provider/vendor/signup",

  // Vendors

  GET_VENDORS: "/api/v1/vendor/getWithFilter",
  ADD_VENDOR: "/api/v1/vendor/add",
  GET_VENDOR_BY_ID: "/api/v1/vendor/getById/",
  REMOVE_VENDOR: "/api/v1/vendor/remove",
  EDIT_VENDOR: "/api/v1/vendor/update",
  BLOCK_UNBLOCK_VENDOR: "/api/v1/vendor/blockUnblock",

  // get assign driver
  GET_ASSIGN_DRIVER: "/api/v1/provider/getassigndriverwithfilter",
  BOOKING_GUEST_ASSIGN_DRIVER: "/api/v1/booking/guest/assign/driver",

  VENDOR_STRIPE_DISCONNECT: "/api/v1/vendor/stripe/disconnect",
  VENDOR_STRIPE_CONNECT: "/api/v1/vendor/stripe/connect",
  VENDOR_PAYOUT: "/api/v1/vendor/payoutTransfer",
  VENDOR_STRIPE_CONNECT_RETURN: "/api/v1/vendor/stripe/connect/return",

};
